export const USERS_COLOR = "#2a78d6";
export const USERS_IN_PROGRESS_COLOR = "#b7d3f6";
